import { useState, useEffect } from "react";

export const useScroll = (id = "") => {
  const idElement = document.getElementById(id);
  const element = idElement ? idElement : document.documentElement;

  const [scroll, setScroll] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleScroll = () => {
      if (!element) return;
      const { scrollTop, scrollLeft } = element;
      setScroll({ left: scrollLeft, top: scrollTop });
    };
    if (!element) return;
    if (idElement) element.addEventListener("scroll", handleScroll);
    else document.addEventListener("scroll", handleScroll);

    return () => {
      if (id) element.removeEventListener("scroll", handleScroll);
      else document.removeEventListener("scroll", handleScroll);
    };
  }, [element, id, idElement]);

  return scroll;
};
